import { useLocale } from "../../../../../../../../hooks/useLocale";
import { TradeQuestionSelectedUK } from "./TradeQuestionSelectedUK";
import { TradeQuestionSelected as TradeQuestionSelectedUS } from "./TradeQuestionSelected";
import type { TradeOption } from "@simplybusiness/mobius-trade-selector";

export type TradeQuestionSelectedProps = {
  trade: TradeOption;
  onEditTrade: () => void;
  primaryText?: string;
  errorMessage?: string;
};

export const TradeQuestionSelected = (props: TradeQuestionSelectedProps) => {
  const { isUK } = useLocale();

  if (isUK) {
    return <TradeQuestionSelectedUK {...props} />;
  }
  return <TradeQuestionSelectedUS {...props} />;
};
